/**
 * <rc-slider> — horizontal scroll-snap slider driven by two arrow buttons.
 * Used on the Recrutement page for the values / benefits / team carousels.
 * Steps by one item (offset delta between the first two items); for a
 * one-item-per-view track that delta equals the viewport width, so the same
 * logic drives both card carousels and full-width member slides.
 */
class RcSlider extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-rc-track]');
    this.prevBtn = this.querySelector('[data-rc-prev]');
    this.nextBtn = this.querySelector('[data-rc-next]');
    if (!this.track) return;

    this.items = Array.from(this.track.children);
    this.prevBtn?.addEventListener('click', () => this.#scrollByStep(-1));
    this.nextBtn?.addEventListener('click', () => this.#scrollByStep(1));
    this.track.addEventListener('scroll', this.#onScroll, { passive: true });
    this.#update();
  }

  disconnectedCallback() {
    this.track?.removeEventListener('scroll', this.#onScroll);
  }

  #step() {
    if (this.items.length < 2) return this.track.clientWidth;
    return this.items[1].offsetLeft - this.items[0].offsetLeft;
  }

  #scrollByStep(dir) {
    this.track.scrollBy({ left: dir * this.#step(), behavior: 'smooth' });
  }

  #onScroll = () => {
    clearTimeout(this._t);
    this._t = setTimeout(this.#update, 60);
  };

  #update = () => {
    const { scrollLeft, scrollWidth, clientWidth } = this.track;
    if (this.prevBtn) this.prevBtn.disabled = scrollLeft <= 1;
    if (this.nextBtn) this.nextBtn.disabled = scrollLeft + clientWidth >= scrollWidth - 1;
  };
}

if (!customElements.get('rc-slider')) {
  customElements.define('rc-slider', RcSlider);
}
